import { Chip, ChipProps } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { TsrctDemandStatus } from '@/generated/gql/graphql';

type ColorMap = { [key: string]: ChipProps['color'] };

const colorMap: ColorMap = {
  [TsrctDemandStatus.INITIALIZED]: 'default',
  [TsrctDemandStatus.COMPLETED]: 'success',
  [TsrctDemandStatus.CANCELLED]: 'error',
  [TsrctDemandStatus.UPSTREAM_DELETED]: 'error',
};

export interface DemandStatusChipProps {
  className?: string;
  status?: keyof typeof TsrctDemandStatus;
}

export const DemandStatusChip = ({ className, status }: DemandStatusChipProps) => {
  const { t } = useTranslation();
  return status ? (
    <Chip
      className={className}
      label={t(`DemandStatus.${status}`)}
      color={colorMap[status]}
      data-intercom-target="Demand/StatusChip"
    />
  ) : null;
};
